import AiGenerativeRemoveSilenceIcon from '@atlaskit/icon-lab/core/ai-generative-remove-silence';
import * as React from 'react';

export function SvgSilenceRemoval() {
  return <AiGenerativeRemoveSilenceIcon label="" testId="ads-refreshed-icon" />;
}
